import {ImageRenderer} from "../components/image/imageRenderer";
import {AnimationPlayer} from "../components/animation/animationPlayer";
import {Button} from "../components/inputObject/button";
import {Vector2} from "../engine/utils/Vector2";
import {Crank} from "../components/inputObject/crank";
import {AppState} from "../app";
import {Rotation} from "../components/transform/rotation";


export function updateSprites({interactiveCanvas, entities, time, soundEvents, animations}: AppState) {

    entities.forEach([Button, ImageRenderer], (e) => {

        e.ImageRenderer.sprite = e.Button.isDown ? e.Button.downImage : e.Button.upImage
    })

    entities.forEach([Crank, Rotation], (e) => {


        const baseAngle = Math.PI / 4 * 5;
        const basePos = e.Position.value
        const handlePos1 = basePos.add(Vector2.fromPolar(5/2, baseAngle))
        const handlePos2 = basePos.add(Vector2.fromPolar(15/2, baseAngle))
        const knobPos = handlePos2.add(Vector2.fromPolar(130/2, e.Rotation.value + Math.PI / 2))

        e.Crank.spindle.Position.value.set(basePos)
        e.Crank.handleBg.Position.value.set(handlePos1)
        e.Crank.handleFg.Position.value.set(handlePos2)
        e.Crank.knob.Position.value.set(knobPos)

        e.Crank.handleFg.Rotation.value = e.Rotation.value
        e.Crank.handleBg.Rotation.value = e.Rotation.value
    })

    entities.forEach([AnimationPlayer, ImageRenderer], (e) => {

        const anim = animations[e.AnimationPlayer.animation]
        if (!anim)
            return
        e.ImageRenderer.sprite = e.AnimationPlayer.currentFrameId != -1 ? anim.sprites[e.AnimationPlayer.currentFrameId] : undefined
    })
}